(() => {
  const ready = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  ready(() => {
    // Listing cards: replace aggressive direct add-to-cart action with clearer product-view CTA.
    document.querySelectorAll('product-card').forEach((card) => {
      const productLink = card.querySelector('.product-title[href], .product-card__media[href]');
      const formWrapper = card.querySelector('product-form');

      if (!productLink || !formWrapper || card.querySelector('.evolve-product-view-cta')) return;

      const viewLink = document.createElement('a');
      viewLink.href = productLink.href;
      viewLink.className = 'bloom-btn bloom-btn--view evolve-product-view-cta';
      viewLink.textContent = 'Produkt ansehen';
      viewLink.setAttribute('aria-label', 'Produkt ansehen');
      formWrapper.replaceWith(viewLink);
    });

    // Replace generic/AI-sounding labels and unclear bundle microcopy.
    document.querySelectorAll('.badge, .mbb-badge, .mbb-btn, .mbb-form button, a, button').forEach((el) => {
      const text = (el.textContent || '').trim();
      if (/direkt\s+kaufbar/i.test(text)) {
        el.textContent = text.replace(/\s*[-–—]?\s*direkt\s+kaufbar/ig, '').trim() || 'Kundenliebling';
      }
      if (/routine\s+ansehen/i.test(text)) {
        el.textContent = text.replace(/routine\s+ansehen/ig, 'Bundle ansehen');
      }
      if (/baue\s+deine\s+persönliche\s+routine/i.test(text)) {
        el.textContent = 'Entdecke passende Produkt-Sets';
      }
    });

    // Desktop PDP accordions: open content to avoid empty whitespace; mobile remains compact.
    if (window.matchMedia('(min-width: 921px)').matches) {
      document.querySelectorAll('.mph-acc details, .product-info details, .product__accordion details').forEach((details) => {
        details.open = true;
      });
    }
  });
})();
